// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { useMutation, useRequest } from "redux-query-react";
import { useSelector } from 'react-redux';
import { isEqual } from "lodash";
import * as runtime from '../runtime';
import { objectToHash } from "common/object-helper";
import { CashflowCustomModelFromJSON, CashflowCustomModelToJSON, } from '../models';
/**
 * Delete cashflow custom model
 * Delete cashflow custom model by id
 */
export function deleteCashflowCustomModelRaw(requestParameters, requestConfig = {}) {
    if (requestParameters.id === null || requestParameters.id === undefined) {
        throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling deleteCashflowCustomModel.');
    }
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    meta.authType = ['bearer'];
    const config = {
        url: runtime.BASE_PATH + `/cashflowcustommodel/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))) + queryString,
        meta,
        update: requestConfig.update || {
            CashflowCustomModel: (prevValue, transformedValue) => {
                const updateValue = { ...prevValue };
                delete updateValue[requestParameters.id];
                return updateValue;
            }
        },
        optimisticUpdate: requestConfig.optimisticUpdate || {
            CashflowCustomModel: (prevValue) => {
                const optimisticValue = { ...prevValue };
                delete optimisticValue[requestParameters.id];
                return optimisticValue;
            }
        },
        rollback: requestConfig.rollback || {
            CashflowCustomModel: (initialValue, currentValue) => {
                const rollbackValue = { ...currentValue };
                rollbackValue[requestParameters.id] = initialValue[requestParameters.id];
                return rollbackValue;
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'DELETE',
            headers: headerParameters,
        },
        body: queryParameters,
    };
    config.queryKey = requestConfig.queryKey || `DeleteCashflowCustomModel-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Delete cashflow custom model
* Delete cashflow custom model by id
*/
/**
 * Mutation hook for deleting a CashflowCustomModel, with optimistic update and optimized rollback in case of failure.
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns [QueryState, RunMutation] queryState and an async call to delete a CashflowCustomModel
 */
export const useDeleteCashflowCustomModel = (customQueryConfig) => {
    return useMutation((id, customQueryParam) => deleteCashflowCustomModel({ id }, { ...customQueryConfig, meta: { ...customQueryConfig?.meta, ...customQueryParam } }));
};
export function deleteCashflowCustomModel(requestParameters, requestConfig) {
    return deleteCashflowCustomModelRaw(requestParameters, requestConfig);
}
/**
 * Retrieve cff custom model by ID
 * Get cashflow custom model by id
 */
export function getCashflowCustomModelByIdRaw(requestParameters, requestConfig = {}) {
    if (requestParameters.id === null || requestParameters.id === undefined) {
        throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getCashflowCustomModelById.');
    }
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    meta.authType = ['bearer'];
    const config = {
        url: runtime.BASE_PATH + `/cashflowcustommodel/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))) + queryString,
        meta,
        update: requestConfig.update || {
            CashflowCustomModel: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'GET',
            headers: headerParameters,
        },
        body: queryParameters,
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = CashflowCustomModelFromJSON(body);
            let key = "";
            if (requestParameters.id) {
                key = `${key}${requestParameters.id}`;
            }
            return { CashflowCustomModel: { [key]: objResponse } };
        }
    };
    config.queryKey = requestConfig.queryKey || `GetCashflowCustomModelById-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Retrieve cff custom model by ID
* Get cashflow custom model by id
*/
/**
 * Use this selector to get a reference to a single CashflowCustomModel matching the id
 * @param id Id of the CashflowCustomModel
 * @returns The CashflowCustomModel object
 */
export const useCashflowCustomModelByIdSelector = (id) => {
    let key = "";
    if (id) {
        key = `${key}${id}`;
    }
    return useSelector((state) => state.entities.CashflowCustomModel[key], isEqual);
};
/**
 * Request hook for a single CashflowCustomModel. Beware, this should not be called without a valid id ***WIP***
 * @param id id of the CashflowCustomModel
 * @returns an array containing the data, query state, and a call for refresh
 * (note : refresh shouldn't be necessary, update to the state should be handle by mutators)
 */
export const useGetCashflowCustomModelById = (requestParameters, customQueryConfig) => {
    const [querystate, forceRefresh] = useRequest(getCashflowCustomModelByIdRaw(requestParameters, customQueryConfig));
    return [
        useCashflowCustomModelByIdSelector(requestParameters.id),
        querystate,
        forceRefresh
    ];
};
export function getCashflowCustomModelById(requestParameters, requestConfig) {
    return getCashflowCustomModelByIdRaw(requestParameters, requestConfig);
}
/**
 * Create new cashflow model or new version of same model
 * Create new cashflow model
 */
export function postCashflowCustomModelRaw(requestParameters, requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    headerParameters['Content-Type'] = 'application/json';
    const { meta = {} } = requestConfig;
    meta.authType = ['bearer'];
    const config = {
        url: runtime.BASE_PATH + `/cashflowcustommodel` + queryString,
        meta,
        update: requestConfig.update || {
            CashflowCustomModel: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'POST',
            headers: headerParameters,
        },
        body: CashflowCustomModelToJSON(requestParameters.cashflowCustomModel),
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = CashflowCustomModelFromJSON(body);
            if (body.id) {
                return { CashflowCustomModel: { [objResponse.id]: objResponse } };
            }
            if (body.data && body.total && requestConfig.queryKey) {
                return { CashflowCustomModel: { [requestConfig.queryKey]: objResponse } };
            }
            return {};
        }
    };
    config.queryKey = requestConfig.queryKey || `PostCashflowCustomModel-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Create new cashflow model or new version of same model
* Create new cashflow model
*/
/**
 * Mutation hook to create a Client
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns [QueryState, RunMutation] queryState and an async call to upsert an array client
 */
export const usePostCashflowCustomModel = (customQueryConfig) => {
    return useMutation((cashflowCustomModel, customQueryParam) => postCashflowCustomModelRaw({ cashflowCustomModel }, { ...customQueryConfig, meta: { ...customQueryConfig?.meta, ...customQueryParam } }));
};
export function postCashflowCustomModel(requestParameters, requestConfig) {
    return postCashflowCustomModelRaw(requestParameters, requestConfig);
}
/**
 * Update cashflow custom model
 * Update cashflow model with new version
 */
export function putCashflowCustomModelRaw(requestParameters, requestConfig = {}) {
    if (requestParameters.id === null || requestParameters.id === undefined) {
        throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling putCashflowCustomModel.');
    }
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    headerParameters['Content-Type'] = 'application/json';
    const { meta = {} } = requestConfig;
    meta.authType = ['bearer'];
    const config = {
        url: runtime.BASE_PATH + `/cashflowcustommodel/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))) + queryString,
        meta,
        update: requestConfig.update || {
            CashflowCustomModel: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'PUT',
            headers: headerParameters,
        },
        body: CashflowCustomModelToJSON(requestParameters.cashflowCustomModel),
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = CashflowCustomModelFromJSON(body);
            if (body.id) {
                return { CashflowCustomModel: { [objResponse.id]: objResponse } };
            }
            if (body.data && body.total && requestConfig.queryKey) {
                return { CashflowCustomModel: { [requestConfig.queryKey]: objResponse } };
            }
            return {};
        }
    };
    config.queryKey = requestConfig.queryKey || `PutCashflowCustomModel-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Update cashflow custom model
* Update cashflow model with new version
*/
/**
 * Mutation hook to update a CashflowCustomModel, with optimistic update and optimized rollback
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns [QueryState, RunMutation] queryState and an async call to update a CashflowCustomModel
 */
export const usePutCashflowCustomModel = (customQueryConfig) => {
    return useMutation((id, cashflowCustomModel, customQueryParam) => putCashflowCustomModelRaw({ id, cashflowCustomModel }, { ...customQueryConfig, meta: { ...customQueryConfig?.meta, ...customQueryParam } }));
};
export function putCashflowCustomModel(requestParameters, requestConfig) {
    return putCashflowCustomModelRaw(requestParameters, requestConfig);
}
